import React, { useEffect, useState } from "react";
import styles from "./PriceTable.module.css";
import { Icon } from "../../icons/icons";
import Skeleton from "react-loading-skeleton";
import { GetPriceList } from "../api";
import ErrorComp from "../ErrorComp";
import DefaultCurrencyFormat from "../DefaultCurrencyFormat";

const PriceTable = ({ currency, id, start2 }) => {
  const [data, setData] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    setData(false);
    setError(false);
    setLoading(true);
    GetPriceList(id, currency, start2)
      .then((response) => {
        if (response.data.error) {
          setError(response.data.error);
          setData([]);
        } else {
          setTimeout(() => {
            setData(response.data);
          }, 200);
        }
        setLoading(false);
      })
      .catch((error) => {
        setError(error.message);
        setLoading(false);
      });
  }, [currency, id, start2]);

  const Loading = () => {
    return <Skeleton count={5} height={67}></Skeleton>;
  };

  return (
    <div className="min-h-[306px]">
      {loading && <Loading />}
      {error && <ErrorComp>{error}</ErrorComp>}
      {data.data &&
        data.data.map((item, key) => (
          <div className={`${styles.PriceItem} group/parent`} key={key}>
            <div className="flex flex-col mr-auto">
              <span className="text-sm font-medium 2xl:text-base">
                {item.title}
              </span>
              <div className={`${styles.subTitle} `}>
                <small className="w-full text-xs">{item.subTitle}</small>
                {item.info && (
                  <div className="relative inline-block cursor-pointer group">
                    <Icon name="info" size={16}></Icon>
                    <div className="group-hover:block hidden absolute bottom-full bg-brand-black text-white rounded-md py-1 left-0 w-[300px] px-2 -translate-x-1/2 ">
                      {item.info}
                    </div>
                  </div>
                )}
              </div>
            </div>
            <span className="px-3 text-sm font-semibold">
              {item?.oran > 0 ? (
                <span
                  className={`block text-xs text-center text-red-600 line-through ${styles.oldPrice}`}
                >
                  <DefaultCurrencyFormat
                    value={item.dailyPriceIndirimsiz}
                    Symbol={item.Symbol}
                  ></DefaultCurrencyFormat>
                </span>
              ) : (
                ""
              )}
              <DefaultCurrencyFormat
                value={item.dailyPrice}
                Symbol={item.Symbol}
              ></DefaultCurrencyFormat>
            </span>
            {/* <span className="px-6 text-sm font-semibold">
              <DefaultCurrencyFormat
                value={item.fiyat}
                Symbol={item.Symbol}
              ></DefaultCurrencyFormat>
            </span> */}
          </div>
        ))}
    </div>
  );
};

export default PriceTable;
